import * as React from "react";
import { forwardRef } from "react";
import { Text } from "@chakra-ui/react";

/**
 * When to use this??
 */
function EsgLabel({ text, ...rest }, ref) {
  return (
    <Text fontSize="sm"
          fontWeight="bold"
          {...rest}
          ref={ref}
    >{text}</Text>
  );
}

export default forwardRef(EsgLabel);
